/** Drop obsolete market controls while preserving compact CCL share inputs. */
export const removeMarketControlParams = (search: string) => {
  const params = new URLSearchParams(search);
  const previous = params.toString();
  for (const key of ["sortBy", "sortDir", "q"]) params.delete(key);
  if (params.get("m") !== "ccl") params.delete("s");
  return params.toString() === previous ? null : params;
};
